import React from 'react'
import { User } from '../Shared/common_defs'
import CollapsibleSection from '../Shared/CollapsibleSection'
import { Table } from '@workwhile/ui'
import { keyValueColumns } from 'components/Users/keyValueColumns'

interface Props {
  user: User
}

const UserLogUrls = ({ user }: Props) => {
  const data = React.useMemo(() => {
    const logURLs = [
      {
        value: 'Intercom conversations',
        link: `https://app.intercom.com/apps/ozmz3fh8/users/show?user_id=${user.id}`,
      },
      {
        value: 'GCP user logs',
        link: `https://console.cloud.google.com/monitoring/dashboards/builder/4f8b3d65-842f-47d5-a264-3405690ef939;filters=var:user_id,val:${user.id};customDuration=today?project=workwhile-247820`,
      },
      {
        value: 'Mobile app bugsnag logs',
        link: `https://app.bugsnag.com/workwhile/workwhile/errors?filters[event.since]=all&filters[search]=${user.firebaseId}`,
      },
      {
        value: 'Sentry error logs for user',
        link: `https://workwhile.sentry.io/issues/?environment=production&project=4506106678411264&project=4508303095562240&project=4510952940699648&query=user%3A%5Bid%3A{user.id}%2Cid%3A${user.firebaseId}%5D&referrer=issue-list&sort=date&statsPeriod=30d`,
      },
      {
        value: 'Mobile app Amplitude user lookup',
        link: `https://app.amplitude.com/analytics/workwhile/project/241707/search/user_id%3D${user.firebaseId}`,
      },
      {
        value: 'Business portal bugsnag logs',
        link: `https://app.bugsnag.com/workwhile/employer/errors?filters[event.since]=all&filters[search]=${user.firebaseId}`,
      },
      {
        value: 'Stripe API logs',
        link: `https://dashboard.stripe.com/${user.stripeAccountIdProd}/workbench/logs?filtered=true&method[0]=post&method[1]=delete&connected_account_id=${user.stripeAccountIdProd}&direction[0]=self&direction[1]=connect_in`,
      },
      {
        value: 'Twilio SMS logs',
        link: `https://console.twilio.com/us1/monitor/logs/sms?to=${user.phoneNumber}&pageSize=50`,
      },
    ]

    const checkrCandidateId = user.checkrStatus?.candidateId
    if (checkrCandidateId) {
      logURLs.push({
        value: 'Checkr API logs',
        link: `https://dashboard.checkr.com/logs/api?page=1&per_page=25&env=US&resource_id=${checkrCandidateId}`,
      })
    }

    return logURLs
  }, [])

  return (
    <CollapsibleSection title="Log Urls" defaultOpen>
      <Table
        variant="borderless"
        data={data}
        columns={keyValueColumns.slice(1)}
      />
    </CollapsibleSection>
  )
}

export default UserLogUrls
